import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BottomNavigation, BottomNavigationAction, Paper, Badge } from '@mui/material';
import useNavigationItems from '../hooks/useNavigationItems';
import { BOTTOM_NAV_HEIGHT } from './layoutSizes';
// TODO v1: import { useChat } from '../contexts/ChatContext';

const BottomNavBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const navigationItems = useNavigationItems();
  // TODO v1: unread count badge — backend not ready yet
  // const { unreadCount } = useChat();

  const currentPath = location.pathname;

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <Paper
      sx={(theme) => ({
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        // DESKTOP LAYOUT: hide bottom nav, replaced by DesktopLayout two-column pattern
        [theme.breakpoints.up('md')]: {
          display: 'none',
        },
      })}
      elevation={3}
    >
      <BottomNavigation
        value={currentPath}
        onChange={(event, newValue) => handleNavigation(newValue)}
        showLabels
        sx={{
          height: BOTTOM_NAV_HEIGHT,
          '& .MuiBottomNavigationAction-root': {
            minWidth: 'auto',
            padding: '6px 12px 8px',
          },
          '& .MuiBottomNavigationAction-label': {
            marginTop: '4px',
          },
        }}
      >
        {navigationItems.map((item) => (
          <BottomNavigationAction
            key={item.path}
            label={item.label}
            value={item.path}
            disabled={item.disabled}
            icon={
              item.badge ? (
                <Badge badgeContent={item.badge} color="error">
                  {item.icon}
                </Badge>
              ) : (
                item.icon
              )
            }
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
};

export default BottomNavBar;
